var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.22707 5.18265C0.676124 5.18265 0.229492 5.63145 0.229492 6.18508C0.229492 6.7387 0.676124 7.1875 1.22707 7.1875L11.2029 7.1875C11.7538 7.1875 12.2004 6.7387 12.2004 6.18508C12.2004 5.63145 11.7538 5.18265 11.2029 5.18265L1.22707 5.18265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22722 5.08275C0.621178 5.08275 0.129883 5.57643 0.129883 6.18542C0.129883 6.79441 0.621178 7.28809 1.22722 7.28809L11.203 7.28809C11.8091 7.28809 12.3004 6.79441 12.3004 6.18542C12.3004 5.57643 11.8091 5.08275 11.203 5.08275L1.22722 5.08275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21244 1.17332C7.21244 0.619699 6.76581 0.170898 6.21486 0.170898C5.66392 0.170898 5.21729 0.619699 5.21729 1.17332V11.1976C5.21729 11.7512 5.66392 12.2 6.21486 12.2C6.76581 12.2 7.21244 11.7512 7.21244 11.1976V1.17332Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31235 1.17298C7.31235 0.563993 6.82106 0.0703125 6.21501 0.0703125C5.60897 0.0703125 5.11768 0.563993 5.11768 1.17298V11.1972C5.11768 11.8062 5.60897 12.2999 6.21501 12.2999C6.82106 12.2999 7.31235 11.8062 7.31235 11.1972V1.17298Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.4,
    height: 12.4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c83bfbb8aa9bfe955beb8b7def481c98.svg";
export { ForwardRef as ReactComponent };